var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-d-loader__container"},[_c('img',{staticClass:"r-d-loader__svg",attrs:{"src":"/images/shared/Robins-And-Day-Loader-Purple.svg","alt":"Loading"}})])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-577a2c78","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/core/components/LoadingSpinner.vue
// module id = QIER
// module chunks = 1 2 4 5 15 17 18 19 21 24 26 32 38